module.exports = __webpack_public_path__ + "img/arrow-right.2f8c863a.svg";